import {BaseModel} from '../base.model';
import {JsonProperty} from '../json-map.util';
import {ProblemModel} from '../problem/problem.model';

class SolutionModel extends BaseModel {

  title: string = undefined as any;
  correctAnswer: string = undefined as any;

  @JsonProperty({ clazz: ProblemModel })
  problem: ProblemModel = undefined as any;


  // TODO: this might should be its own Model
  wrongAnswers: string = undefined as any;

  parse(json: Object) {
    if (json) {
      super.parse(json);
    }

    return this;
  }
}


export { SolutionModel };



